import * as React from "react";

import { Experiment, Variant } from "client/components";
import { ValueProps } from "client/splitTests/RedesignSignUp";

import { OneQAAT } from "./1QAAT";
import { BaseLayout } from "./BaseLayout";
import { Control } from "./Control";

export const LeadForm: React.FC = () => (
  <Experiment
    fallback={<Control />}
    flag="merchantPortalExperimentRedesignSignUp"
  >
    <Variant type="Control">
      <BaseLayout leftColumn={<ValueProps />} />
    </Variant>
    <Variant type="1QAAT_ValueProps">
      <BaseLayout leftColumn={<ValueProps />} rightColumn={<OneQAAT />} />
    </Variant>
    <Variant type={["1QAAT_4page_contact_first", "1QAAT_4page_contact_last"]}>
      <BaseLayout leftColumn={<ValueProps />} rightColumn={<OneQAAT />} />
    </Variant>
  </Experiment>
);
